/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Enhance_Description_And_TagsInputs */

const en_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI enhance description & tags`)
};

const es_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar descripción y etiquetas con IA`)
};

const fr_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorer la description et les tags avec l'IA`)
};

const de_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung & Tags mit KI verbessern`)
};

const ja_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIで説明とタグを強化する`)
};

const zh_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 增强描述和标签`)
};

const ar_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحسين الوصف والعلامات بالذكاء الاصطناعي`)
};

const id_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sempurnakan deskripsi & tag`)
};

const it_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliora la descrizione & i tag con l'IA`)
};

const ru_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Улучшить описание и теги с помощью ИИ`)
};

const pt_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhorar descrição e tags com IA`)
};

const ko_ai_enhance_description_and_tags = /** @type {(inputs: Ai_Enhance_Description_And_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI로 설명 및 태그 강화하기`)
};

/**
* | output |
* | --- |
* | "AI enhance description & tags" |
*
* @param {Ai_Enhance_Description_And_TagsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_enhance_description_and_tags = /** @type {((inputs?: Ai_Enhance_Description_And_TagsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Enhance_Description_And_TagsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_enhance_description_and_tags(inputs)
	if (locale === "es") return es_ai_enhance_description_and_tags(inputs)
	if (locale === "fr") return fr_ai_enhance_description_and_tags(inputs)
	if (locale === "de") return de_ai_enhance_description_and_tags(inputs)
	if (locale === "ja") return ja_ai_enhance_description_and_tags(inputs)
	if (locale === "zh") return zh_ai_enhance_description_and_tags(inputs)
	if (locale === "ar") return ar_ai_enhance_description_and_tags(inputs)
	if (locale === "id") return id_ai_enhance_description_and_tags(inputs)
	if (locale === "it") return it_ai_enhance_description_and_tags(inputs)
	if (locale === "ru") return ru_ai_enhance_description_and_tags(inputs)
	if (locale === "pt") return pt_ai_enhance_description_and_tags(inputs)
	return ko_ai_enhance_description_and_tags(inputs)
});